import { render, staticRenderFns } from "./tree-select.vue?vue&type=template&id=6dfd1938&scoped=true"
import script from "./tree-select.vue?vue&type=script&lang=js"
export * from "./tree-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfd1938",
  null
  
)

export default component.exports